import { useContext } from 'react';
import { useServices } from '../../../hooks/ServiceHooks';
import { ServiceDisplayProps } from '../../../pages/ServicesPage';
import { ModelsService } from '../../../services/ModelsService';
import { AppContext } from '../../../state/AppContextProvider';
import { Error404 } from '../../globals/Error404';
import ServiceModalContent from './ServiceModalContent';

/**
 * Service page level > 1
 * @param props
 * @returns
 */
const Service: React.FC<ServiceDisplayProps> = ({ slugs }) => {
  const { services } = useServices();

  const { state } = useContext(AppContext);

  const currentSlug = '/services/' + slugs.join('/');

  if (services.length === 0) {
    // loading...
    return <></>;
  }

  const service = services.find(
    (s) => ModelsService.getServiceFullSlug(s) === currentSlug
  );

  if (!service) {
    // page not found...
    return <Error404 />;
  }

  const backButtonUrl = state.previousPath.startsWith('/services')
    ? state.previousPath
    : '/services/tabs/campus';

  return (
    <ServiceModalContent
      services={services}
      service={service}
      backUrl={backButtonUrl}
    />
  );
};
export default Service;
